"use strict";

exports.__esModule = true;
exports.ZIndex = ZIndex;
var ZIndexValues = {
  Page: 1,
  Notification: 4000,
  Modal: 5000,
  Tooltip: 6000
};

function ZIndex(layerName) {
  var zIndexValue = ZIndexValues[layerName];

  if (!zIndexValue) {
    throw new Error("ZIndex: Layer with name ".concat(layerName, " does NOT exist. Layers = ").concat(Object.keys(ZIndexValues).join(', ')));
  }

  return zIndexValue;
}
//# sourceMappingURL=ZIndex.js.map